import { render } from "./OapProductVariantSelector.vue?vue&type=template&id=08a9f316"
import script from "./OapProductVariantSelector.vue?vue&type=script&lang=js"
export * from "./OapProductVariantSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__